import { z } from "zod";

import { PropertyAttributeTypeId, PropertySchemaType } from "~/common/types";

const zSelectOption = z.object({
  value: z.string().min(1),
  label: z
    .object({
      en: z.string().optional(),
      ja: z.string().optional(),
    })
    .optional(),
});

export const zSelectOptions = z.array(zSelectOption);
export type SelectOption = z.infer<typeof zSelectOption>;

const zURLAllowListItem = z.object({
  value: z.string(),
  regex: z.string(),
});
export const zURLAllowList = z.array(zURLAllowListItem);
export type URLAllowList = z.infer<typeof zURLAllowList>;

export const zPropertySchemaAssociationFormData = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  description: z.string().optional(),
  position: z.number().optional(),
  required: z.boolean(),
  unique: z.boolean(),
  propertyAttributeTypeId: z.nativeEnum(PropertyAttributeTypeId).nullish(),
  propertySchema: z.object({
    id: z.string().optional(),
    propertyTypeId: z.nativeEnum(PropertySchemaType),
    selectOptions: zSelectOptions,
    urlAllowList: zURLAllowList.optional(),
  }),
});

export type PropertySchemaAssociationFormData = z.infer<typeof zPropertySchemaAssociationFormData>;

export interface PropertySchemaAssociationsFormDataBase {
  propertySchemaAssociations?: PropertySchemaAssociationFormData[];
}
